import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow secure files.
 */
export class SecureFileOperations {
  constructor(private client: BaserowClient) {}
  
  // Secure file methods will be implemented here
} 